import axios from "axios";

export const state = {
    purchasecarts: [],
};

export const getters = {
    purchasecarts: state => state.purchasecarts,
};

export const mutations = {
    setCart(state, newValue) {
        state.purchasecarts = newValue
    },
};

export const actions = {
    fetchPurchaseCart({ commit }) {
        axios.get('/purchasecart').then(res => {
            commit('setCart', res.data.purchases);
        })
    },
};
